<!-- 研讨会-业务组件-发送对应房间 -->
<template>
  <div class="plv-ia-vclass-dialog" @click.self="close">
    <div class="plv-ia-vclass-dialog__container">
      <div class="plv-ia-vclass-dialog-header">
        <span class="plv-ia-vclass-dialog-header">
          {{ sendRoomTitle }}
        </span>
        <span class="plv-ia-vclass-dialog-header-close" @click="close">
        </span>
      </div>
      <div class="plv-ia-vclass-send-room">
        <div class="plv-ia-vclass-send-room-content">
          <ul>
            <li v-for="(item, index) in sendRoomList" :key="index" class="plv-ia-vclass-send-room-item">
              <input type="checkbox"
                     :class="{'plv-ia-vclass-send-room-item--disable': item.disabled}"
                     :disabled="item.disabled"
                     v-model="item.checked"
                     @change="(e) => changeCheckBox(e, index)"/>
              <span :class="{'plv-ia-vclass-send-room-item--disable': item.disabled}" @click="changeVal(index, !item.checked)">{{ item.label }}</span>
              <span v-if="item.tip" :style="item.tipStyle"> {{ item.tip }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="plv-ia-vclass-dialog-footer">
        <div class="plv-ia-vclass-dialog-btn-group">
          <div class="plv-ia-vclass-dialog-btn plv-ia-vclass-dialog-btn--cancel" @click="close">
            取消
          </div>
          <div
            class="plv-ia-vclass-dialog-btn plv-ia-vclass-dialog-btn--confirm"
            :class="{'plv-ia-vclass-dialog-btn--disable': !isSubmit}"
            @click="confirm">
            {{ confirmText }}
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Locale from '@/mixins/locale';

export default {
  name: 'send-room',
  inject: ['_interactionApp'],
  mixins: [Locale],
  props: {
    sendRoomList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    sendRoomTitle: {
      type: String,
      default: '提示'
    },
    confirmText: String
  },
  data() {
    return {
      checked: false,
    };
  },
  computed: {
    isSubmit() {
      let status = false;
      for (let i = 0; i < this.sendRoomList.length; i++) {
        const item = this.sendRoomList[i];
        if (item.checked) {
          status = true;
          break;
        }
      }
      return status;
    }
  },
  methods: {
    changeCheckBox(e, index) {
      this.changeVal(index, e.target.checked);
    },
    changeVal(index, checked) {
      if (this.sendRoomList[index].disabled) {
        return;
      }
      const list = JSON.parse(JSON.stringify(this.sendRoomList));
      list[index].checked = checked;
      this._interactionApp.$emit('change-send-room-list', list);
    },
    close() {
      this.$emit('close');
    },
    confirm() {
      if (this.isSubmit) {
        this.$emit('confirm');
      }
    }
  },
};
</script>

<style lang="scss">
.plv-ia-vclass-dialog-btn--disable {
  background: #BEBEBE !important;
  cursor: not-allowed !important;
}
.plv-ia-vclass-send-room-item--disable {
  color: #999999;
  cursor: not-allowed !important;
}

.plv-ia-vclass-send-room {
  display: flex;
  flex-direction: row;
  justify-content: center;
  min-height: 40px;
  padding-left: 8px;
  padding-top: 25px;
}

.plv-ia-vclass-send-room-title {
  font-size: 14px;
}

.plv-ia-vclass-send-room-content {
  flex: 1;
  padding-left: 8px;

  ul {
    padding-top: 2px;
  }

  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    height: 20px;
    line-height: 20px;

    span {
      margin-left: 4px;
      font-size: 12px;
      display: block;
      cursor: pointer;
    }
  }
}

.plv-ia-vclass-dialog {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .plv-ia-vclass-dialog__container {
    width: 400px;
    padding: 8px 8px 14px;
    background: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
    border-radius: 6px;
  }

  .plv-ia-vclass-dialog-header {
    height: 28px;
    line-height: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 8px;
    font-size: 18px;
    color: #333333;
  }

  .plv-ia-vclass-dialog-header-close {
    display: inline-block;
    width: 28px;
    height: 28px;
    background-image: url('../../assets/images/icon-dialog-close.png');
    background-size: 100% 100%;
    cursor: pointer;
  }

  .plv-ia-vclass-dialog-footer {
    display: flex;
    justify-content: right;

    .plv-ia-vclass-dialog-btn-group {
      display: flex;
      align-items: center;
      margin-right: 16px;

      .plv-ia-vclass-dialog-btn {
        border-radius: 4px;
        text-align: center;
        padding: 0 16px;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        font-size: 12px;
        color: #FFFFFF;
        cursor: pointer;
      }

      .plv-ia-vclass-dialog-btn + .plv-ia-vclass-dialog-btn {
        margin-left: 12px;
      }

      .plv-ia-vclass-dialog-btn--cancel {
        background: #FFFFFF;
        border: 1px solid #BEBEBE;
        border-radius: 4px;
        color: #666666;
      }

      .plv-ia-vclass-dialog-btn--confirm {
        background: #366BEE;
        border-radius: 4px;
      }
    }
  }
}

</style>
